// extracted by mini-css-extract-plugin
export default {"header":"header_header__lOwdN","container":"header_container__N124p","logo":"header_logo__dpz63","label":"header_label__7jIFN"};